// extracted by mini-css-extract-plugin
export default {"manageSubscriptionWrapper":"ManageSubscriptionPage_manageSubscriptionWrapper__5JTR5"};